import type { ReactNode } from 'react';
import React, { useRef } from 'react';

import { Provider as NonceProvider } from 'src/shared/hooks/useNonce';
import { isBrowser } from 'src/shared/utils/environment';

interface Props {
  children: ReactNode;
}

interface ServerProps extends Props {
  nonce: string;
}

interface ClientProps extends Props {
  window: Window;
}

const MISSING_NONCE = 'missing-nonce';

const Provider = ({ children, ...props }: ServerProps | ClientProps) => {
  const ref = useRef(
    // eslint-disable-next-line react/destructuring-assignment
    'nonce' in props ? props.nonce : props.window.nonce ?? MISSING_NONCE,
  );

  if (isBrowser() && window.nonce) delete window.nonce;

  return (
    <NonceProvider value={{ nonce: ref.current }}>{children}</NonceProvider>
  );
};

export { Provider };
